import React, { useState, useEffect, Fragment } from "react";
import axios from "axios";
import { uri } from "../../../help/Api";
import { stElemnt } from "../../../St/Reviews/cStyle";
import LoadingPage from "../../../services/LoadingPage";
import * as _ from "lodash";
import { AppBar, ButtonBase, Grid, Typography } from "@material-ui/core";
import useChunkMyData from "../../../components/Hooks/useChunkMyData";
import { sto } from "../../../Context/InshData";
import { useInvAF } from "../../../St/Reviews/UseStyle";
import Header from "./A4/Header";
import Body from "./A4/Body";
import Footer from "./A4/Footer";
import './watermark-image.css';

function BillPage(props) {
    const { locInv, found, sta, inv, chunk, } = props;
    const clas = useInvAF();
    const WaterMarkImage = () => {
        return (
            <div
            className="watermark-image">
                <img
                    src={`data:image/jpeg;base64,${found.Logo}`}
                    alt="Watermark"
                />
                <h1>{found.nameA}</h1>
            </div>

        );
    };
    const premiApp = JSON.parse(localStorage.getItem("premiApp")) || {};

    const WaterMarkName = () => {
        return (
            <div
            className="watermark-image">
                <h1>{found.nameA}</h1>
            </div>

        );
    };
    return (
        <div  >
          
            <Grid item container style={{ ...stElemnt.AF.Reviws.pdf_page }}>
                <Fragment style={{position:"fixed",zIndex:0}}>
                {premiApp.billTemplate === 23 ?
                (<WaterMarkName/>):
                (<WaterMarkImage/>)}             
                    <Grid item xs={12} justifyContent="center" style={{ minHeight: "19cm", maxHeight: "19cm", border: "dotted 1px #393939" }}>
                       {/* <br/> */}
                        <Header locInv={locInv} sta={sta ?? {}} info={found} />
                        <Body data={chunk ?? []} />
                    </Grid>
                    <Footer InvForFatora={inv} found={found} sta={sta ?? {}} locInv={locInv} />
                </Fragment>
            </Grid>
        </div>
    );
}
function InvTempalteCon(props) {
    const locInv = JSON.parse(localStorage.getItem("datainv")) || {};
    const [found, setFound] = useState({});
    const [sta, setSta] = useState({});
    const [inv, setInv] = useState({});
    const [loading, setLoading] = useState(true);
    const [chunks, setChunks] = useState([]);
    const premiApp = JSON.parse(localStorage.getItem("premiApp")) || {};

    const getInfo = async () => {
        // alert('getInfo')
        const tb = {
            GetFoundation: true,
            Rpt_Inv: true,
            wait: true,
            stor: sto,
            SettInvsApp: true,
            parms: {
                lprocid: locInv.proc_id,
                ibranchid: sto.branchi,
                iFoundid: 1,
                branch: sto.branchi,
                sProcTypeInvProc: locInv.ProcTypeInvProc,
            },
            autos: {},
        };
        console.log(tb);
        await axios
            .post(`${uri}Res`, tb)
            .then((res) => {
                setSta({ info: res.data.RptInv, tot: res.data.infoBill, StngIA: res.data.SettInvsApp });
                console.log("res.data.RptInv");
                const data2 = res.data.RptInv.map((row, i) => {
                    return {
                        ...row,
                        no: i + 1,
                    };
                });
                if (premiApp.billTemplate === 16) {
                    setChunks(_.chunk(data2, 9));
                } else {
                    setChunks(_.chunk(data2, 11));
                }
                setFound(res.data.Found);
            })
            .catch((error) => {
                console.log("catch");
            });
    };
    const getInv = async () => {
        axios
            .get(uri + `InvForFatora?proc_id=${locInv.proc_id}`)
            .then((res) => {
                console.log("the inve for fatoora", res.data);
                setInv(res.data);
            })
            .catch((error) => { });
    };
    useEffect(() => {
        setTimeout(async () => {
            await getInfo();
            await getInv();
            setLoading(false);
        }, 0);
    }, []);

    if (!found || !sta || loading) return <LoadingPage />;

    return (
        <Typography component="div" style={stElemnt.AF.Reviws.ReviwsJard}>

            <Typography component="div" >
                {chunks.map((page, i) => {
                    return (
                        <BillPage
                            {...{
                                locInv,
                                found,
                                sta,
                                inv,
                                chunk: page,
                            }}
                        />
                    );
                })}
            </Typography>
        </Typography>
    );
}
export default InvTempalteCon;
